export default __webpack_public_path__ + "static/media/audiox-project.c54e9e66.jpeg";